/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".application-lateral-nav .active{background:var(--intersocio-red)}  .application-lateral-nav .active:hover{color:#fff}"];
export { styles as styles };
